import GeoBlockingTemplatesList from '@/components/GeoBlockingTemplatesList'
import ContainerLoader from '@/components/LoaderContainer/ContainerLoader'
import { TitleSetter } from '@/components/Title'
import { useGeoBlockingTemplatesStore } from '@/stores/useGeoTemplateStore'

export const GeoTemplatesView = () => {
  const { isLoading } = useGeoBlockingTemplatesStore()
  return (
    <>
      <TitleSetter title="Geo Templates" />
      {isLoading ? <ContainerLoader /> : <GeoBlockingTemplatesList />}
    </>
  )
}
